import React from 'react'
import { Link } from 'react-router-dom';



function Footer() {
  return (
    <div>
        <>
            <footer className="footer-area footer-style-one-wrapper bg-color-footer  tmp-section-gap">
                <div className="container">
                <div className="footer-main footer-style-one">
                    <div className="row g-5">
                    <div className="col-lg-4 col-md-6">
                        <div className="single-footer-wrapper border-right mr--20">
                        <div className="logo">
                            <Link to="/">
                            <img src="assets/images/logo/logo.png" alt="logo"   style={{ filter: "brightness(0) invert(1)" }}/>
                            </Link>
                        </div>
                        <p className="description">
                            Highly qualified tax consultants with many years of experience in the field offer a full range of services to help you build a sound financial future.
                        </p>
                        <div className="day-time">
                            <div className="icon">
                            <i className="fa-solid fa-alarm-clock fs-2" />
                            </div>
                            <div className="content">
                            <div className="day">Sunday - Friday:</div>
                            <div className="time">9:00 AM – 8:00 PM</div>
                            </div>
                        </div>
                        <ul className="social-icons solid-social-icons rounded-social-icons">
                           
                            <li>
                            <Link to="https://www.instagram.com/faaccountingandbusiness/" target="_blank">
                                <i className="fa-brands fa-instagram" />
                            </Link>
                            </li>
                        </ul>
                        </div>
                    </div>
                    
                    <div className="col-lg-2 col-md-6">
                        <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                        <h5 className="ft-title">Services</h5>
                        <ul className="ft-link">
                            <li>
                            <Link to={'/book-keeping'}>Book Keeping</Link>
                            </li>
                            <li>
                            <Link to={'/tax'}>Tax</Link>
                            </li>
                            <li>
                            <Link to={'/payroll-management'}>Payroll Management</Link>
                            </li>
                            <li>
                            <Link to={'/Business-Formation'}>Business Formation</Link>
                            </li>
                            <li>
                            <Link to={'/business-consultation'}>Business Consultation</Link>
                            </li>
                            
                        </ul>
                        </div>
                              </div>
                              <div className="col-lg-2 col-md-6">
                        <div className="single-footer-wrapper pl-50 pl_md--0 pl_sm--0">
                        <h5 className="ft-title">Quick Link</h5>
                        <ul className="ft-link">
                            <li>
                            <Link to={'/About'}>About ANBS LLC</Link>
                            </li>
                            <li>
                            <Link to={'/service'}>Services</Link>
                            </li>
                            <li>
                            <Link to={'/contact-us'}>Contact Us</Link>
                            </li>
                            
                        </ul>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6">
                        <div className="single-footer-wrapper">
                        <h5 className="ft-title">Official info:</h5>
                        <ul className="ft-link">
                            <li className="ft-location">
                           16314 Amber Brown Drive, Hockley, TX 77447
                            </li>
                            <li>
                            <div className="single-contact">
                                <div className="icon">
                                <i className="fa-solid fa-envelope-open-text" />
                                </div>
                                <div className="content">
                                <span>E-mail:</span>
                                <Link to="mailto:info@anbsllc.com">
                                    info@anbsllc.com
                                </Link>
                                </div>
                            </div>
                            </li>
                            <li>
                            <div className="single-contact">
                                <div className="icon">
                                <i className="fa-light fa-phone" />
                                </div>
                                <div className="content">
                                <span>Phone:</span>
                                <Link to="tel:8323510418">832-351-0418</Link>
                                </div>
                            </div>
                            </li>
                        </ul>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
            </footer>
            <div className="copyright-area-one">
                <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                    <div className="main-wrapper">
                        <p>
                                      © ANBS LLC 2025 | Managed By  { " "}
                                      <Link style={{ color: "white" }} target="_blank" to="https://www.expobird.com/">ExpoBird</Link>
                        </p>
                    </div>
                    </div>
                </div>
                </div>
            </div>
        </>
        
    </div>
  )
}

export default Footer